<template>
  <div class="page_container warehousingRecordPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >物流&订单管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>出库管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <div class="screen_wrap flex-rowr">
            <div
              v-for="(item, index) in orderStateList"
              :key="index"
              class="txt"
              :class="params.ordertype == item.value ? 'active' : ''"
              @click="handleState(1, item.value)"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
        <div class="filter flex-rowr">
          <div class="screen_wrap flex-rowr">
            <div
              v-for="(item, index) in ordertypeList"
              :key="index"
              class="txt"
              :class="params.orderstate == item.value ? 'active' : ''"
              @click="handleState(2, item.value)"
            >
              {{ item.text }}
            </div>
          </div>
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入关键字查找→"
              @keyup.enter.native="handleSearch"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示订单列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
        id="table"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl" @click="handleDetail(item.id)">
                  <div class="block">
                    <p>
                      订单ID：<span>{{ item.orderid }}</span>
                    </p>
                    <p>
                      订单编号：<span>{{
                        item.orderno ? item.orderno : ""
                      }}</span>
                    </p>
                    <p>
                      订单类型：<span>{{
                        item.ordertypestr ? item.ordertypestr : ""
                      }}</span>
                    </p>
                    <p>
                      创建时间：<span>{{ item.createdate | formatDate }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      收件人：<span>{{ item.truename }}</span>
                    </p>
                    <p>
                      收件人联系方式：<span>{{ item.cellphone }}</span>
                    </p>
                    <p>
                      物流信息：<span>{{ item.order_addr }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      物流类型：<span>{{ item.service_company }}</span>
                    </p>
                    <p>
                      发货物流订单号：<span>{{ item.service_no }}</span>
                    </p>
                    <p>
                      订单状态：<span class="red">{{ item.orderstate }}</span>
                    </p>
                    <!-- <p>
                      订单情况：<span class="red">{{
                        item.service_state
                      }}</span>
                    </p> -->
                  </div>
                  <div class="block">
                    <p>
                      订单物流状态：<span class="red">{{
                        item.service_state
                      }}</span>
                    </p>
                    <p>
                      用户是否验收：<span>{{
                        item.isrec == 0 ? "未收货" : "已收货"
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="edit_group flex-rowr">
                <div class="detail_icon" @click="handleForm(item.id)">
                  <!-- <i class="iconfont icon-a-chuku2"></i> -->
                  <el-image
                    style="width: 35px; height: 40px"
                    :src="require('@/assets/images/outbound_icon.png')"
                  ></el-image>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="暂无入库记录"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import { encryptstringadd } from "../../api/api";
import { getLogisticsList } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "outboundList",
  data() {
    return {
      listTotal: 0,
      params: {
        pageindex: 1,
        pagesize: 10,
        qyguid: "",
        keyword: "",
        ordertype: "",
        orderstate: "待发货",
      },
      // 订单状态
      orderStateList: [
        { text: "全部", value: "" },
        { text: "普通商品订单", value: 2 },
        { text: "批发订单", value: 44 },
        { text: "线下支付订单", value: 55 },
        { text: "销售业务员订单", value: 66 },
      ],
      // 订单类型
      ordertypeList: [
        { text: "待发货", value: "待发货" },
        { text: "已发货（待签收）", value: "已发货" },
        { text: "已收货", value: "已签收" },
        { text: "全部", value: "" },
      ],
      loading: false,
      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    this.params.qyguid = userInfo.qy ? userInfo.qy.qyguid : "";
    this.initData();
  },
  methods: {
    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.initData();
    },
    handleSearch() {
      this.params.pageindex = 1;
      this.initData();
    },

    // 重置数据
    handleRest() {
      this.params.pageindex = 1
      this.params.keyword = ''
      this.params.ordertype = ''
      this.params.orderstate = '待发货'
      this.initData()
    },
    initData() {
      let { params } = this;
      this.loading = true;
      getLogisticsList(params).then((res) => {
        res.list.forEach((v) => {
          let parsedData;
          try {
            parsedData = JSON.parse(v.order_goods);
          } catch (error) {
            // 在转换失败时提供默认值
            parsedData = v.order_goods;
          }
          v.order_goods = parsedData;
        });
        console.log(res.list, "=====res.list");
        this.dataList = res.list;
        this.listTotal = res.total;
        // 加载状态结束
        this.loading = false;
      });
    },

    // 筛选状态
    handleState(type, value) {
      if(value == 66) {
        this.$message.warning("即将开放");
        return
      }
      if (type == 1) {
        this.params.ordertype = value;
      } else if (type == 2) {
        this.params.orderstate = value;
      }
      this.initData();
    },

    // 物流详情
    handleDetail(id) {
      this.encryptstringadd("outboundDetail", { id }, "");
      // this.$router.push(`/outboundIndex/outboundDetail/${id}`);
      //  this.$router.push({name:'outboundDetail', params:{id}})
    },
    handleForm(id) {
      this.encryptstringadd("outboundItemForm", { id }, "_blank");
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params, type) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          if (type != "") {
            window.open(this.$router.resolve({ name, params }).href, "_blank");
          } else {
            this.$router.push({
              name,
              params,
            });
          }
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .screen_wrap {
    font-size: 14px;
    margin-right: 30px;
    .txt {
      cursor: pointer;
      margin-right: 20px;
      &.active {
        font-size: 16px;
        color: red;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .search_wrap {
    width: 280px !important;
  }
  .main_container {
    .select_add {
      p {
        &:last-child {
          margin-left: 49px;
        }
      }
    }
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .red {
      color: #ee0032;
    }
  }
  .detail_icon {
    cursor: pointer;
  }
  .intro_box {
    cursor: pointer;
  }
}
</style>